import { commitMutation, graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation UpdateDocumentInstanceMutation($id: ID!, $pages: [DocumentSectionInput!]!) {
    updateDocumentInstance(id: $id, pages: $pages) {
      ok
      error
    }
  }
`;

export default ({
  id,
  pages
}, done) => {
  const args = {
    id,
    pages
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables: args,
      onCompleted: ({ updateDocumentInstance }) => basicMutationOnCompleted(updateDocumentInstance, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
